export default {
  'AdminUser': {
    collection: 'adminUsers',
    element: 'adminUser',
    label: 'name',
    enum: {
    },
    associations: {
      roles: {
        foreign_key: 'admin_user_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'admin_user_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      operation_records: {
        foreign_key: 'operator_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      operatable_records: {
        foreign_key: 'operatable_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
    }
  },
  'AdminUsersRole': {
    collection: 'adminUsersRoles',
    element: 'adminUsersRole',
    label: 'id',
    enum: {
    },
    associations: {
      admin_user: {
        foreign_key: 'admin_user_id',
        primary_key: 'id',
        class_name: 'AdminUser',
        polymorphic: false
      },
      role: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
    }
  },
  'Role': {
    collection: 'roles',
    element: 'role',
    label: 'name',
    enum: {
      kinds: [
        'super',
        'application',
        'custom',
      ],
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      operatable_records: {
        foreign_key: 'operatable_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'role_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
    }
  },
  'Application': {
    collection: 'applications',
    element: 'application',
    label: 'name',
    enum: {
    },
    associations: {
      creator: {
        foreign_key: 'creator_id',
        primary_key: 'id',
        class_name: 'AdminUser',
        polymorphic: false
      },
      wechat_application: {
        foreign_key: 'wechat_application_id',
        primary_key: 'id',
        class_name: 'BsWechatMiniProgram::Application',
        polymorphic: false
      },
      pages: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Page',
        polymorphic: false
      },
      operation_records: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'OperationRecord',
        polymorphic: false
      },
      admin_users_roles: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      roles: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Role',
        polymorphic: false
      },
      application_admin_users_role: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'AdminUsersRole',
        polymorphic: false
      },
      custom_pages: {
        foreign_key: 'target_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
      users: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      poster_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      poster_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      login_video_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      login_video_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      share_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      share_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      logo_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      logo_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'ActiveStorage::Attachment': {
    collection: 'activeStorage/attachments',
    element: 'activeStorage/attachment',
    label: 'name',
    enum: {
    },
    associations: {
      record: {
        foreign_key: 'record_id',
        class_name: 'Record',
        polymorphic: true
      },
      blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'Banner': {
    collection: 'banners',
    element: 'banner',
    label: 'id',
    enum: {
      page_positions: [
        'index_top',
      ],
      kinds: [
        'web_link',
        'image',
        'mp_link',
        'external_mp_link',
      ],
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'User': {
    collection: 'users',
    element: 'user',
    label: 'email',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    },
    associations: {
      user_oauth_identity_accounts: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'UserOauthIdentityAccount',
        polymorphic: false
      },
      profile: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Profile',
        polymorphic: false
      },
      oauth_identity_accounts: {
        foreign_key: 'oauth_identity_account_id',
        primary_key: 'id',
        class_name: 'OauthIdentityAccount',
        polymorphic: false
      },
      images: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'Image',
        polymorphic: false
      },
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      avatar_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      avatar_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'Profile': {
    collection: 'profiles',
    element: 'profile',
    label: 'name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
    }
  },
  'ActiveStorage::Blob': {
    collection: 'activeStorage/blobs',
    element: 'activeStorage/blob',
    label: 'id',
    enum: {
    },
    associations: {
      variant_records: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::VariantRecord',
        polymorphic: false
      },
      preview_image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      preview_image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      attachments: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'Attachment',
        polymorphic: false
      },
      taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      base_tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      tag_taggings: {
        foreign_key: 'taggable_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
      tags: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: 'ActsAsTaggableOn::Tag',
        polymorphic: false
      },
      uploader: {
        foreign_key: 'uploader_id',
        class_name: 'Uploader',
        polymorphic: true
      },
    }
  },
  'ActsAsTaggableOn::Tag': {
    collection: 'actsAsTaggableOn/tags',
    element: 'actsAsTaggableOn/tag',
    label: 'name',
    enum: {
    },
    associations: {
      taggings: {
        foreign_key: 'tag_id',
        primary_key: 'id',
        class_name: '::ActsAsTaggableOn::Tagging',
        polymorphic: false
      },
    }
  },
  'Page': {
    collection: 'pages',
    element: 'page',
    label: 'title',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      wxacode_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      wxacode_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'PresetPage': {
    collection: 'presetPages',
    element: 'presetPage',
    label: 'title',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      wxacode_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      wxacode_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'StaticPage': {
    collection: 'staticPages',
    element: 'staticPage',
    label: 'title',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      wxacode_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      wxacode_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'CustomPage': {
    collection: 'customPages',
    element: 'customPage',
    label: 'title',
    enum: {
    },
    associations: {
      target: {
        foreign_key: 'target_id',
        class_name: 'Target',
        polymorphic: true
      },
      formal_custom_page: {
        foreign_key: 'draft_custom_page_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
      draft_custom_page: {
        foreign_key: 'draft_custom_page_id',
        primary_key: 'id',
        class_name: 'CustomPage',
        polymorphic: false
      },
    }
  },
  'HotWord': {
    collection: 'hotWords',
    element: 'hotWord',
    label: 'name',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
    }
  },
  'OperationRecord': {
    collection: 'operationRecords',
    element: 'operationRecord',
    label: 'id',
    enum: {
    },
    associations: {
      application: {
        foreign_key: 'application_id',
        primary_key: 'id',
        class_name: 'Application',
        polymorphic: false
      },
      operator: {
        foreign_key: 'operator_id',
        class_name: 'Operator',
        polymorphic: true
      },
      operatable: {
        foreign_key: 'operatable_id',
        class_name: 'Operatable',
        polymorphic: true
      },
    }
  },
  'Option': {
    collection: 'options',
    element: 'option',
    label: 'name',
    enum: {
    },
    associations: {
      cover_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      cover_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      creator: {
        foreign_key: 'creator_id',
        class_name: 'Creator',
        polymorphic: true
      },
    }
  },
  'Image': {
    collection: 'images',
    element: 'image',
    label: 'title',
    enum: {
      states: [
        'pending',
        'completed',
        'failed',
      ],
    },
    associations: {
      user: {
        foreign_key: 'user_id',
        primary_key: 'id',
        class_name: 'User',
        polymorphic: false
      },
      raw_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      raw_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      origin_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      origin_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
      results_attachments: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      results_blobs: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
  'SampleImage': {
    collection: 'sampleImages',
    element: 'sampleImage',
    label: 'name',
    enum: {
    },
    associations: {
      image_attachment: {
        foreign_key: 'record_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Attachment',
        polymorphic: false
      },
      image_blob: {
        foreign_key: 'blob_id',
        primary_key: 'id',
        class_name: 'ActiveStorage::Blob',
        polymorphic: false
      },
    }
  },
}
